import ReactGA from 'react-ga4';

const trackingId = 'G-D3CJSR2Z4K';
let isInitialized = false;

export const initGA = () => {
  if (isInitialized) {
    return;
  }
  isInitialized = true;
  ReactGA.initialize(trackingId);
};

export const logPageView = (title: string) => {
  // ReactGA.send({
  //   hitType: 'pageview',
  //   page: window.location.pathname,
  //   title: title,
  // });
};

export const logEvent = (action: string) => {
  ReactGA.event({
    category: 'Form',
    action: action,
    transport: 'xhr',
  });
};
